module.exports = __webpack_public_path__ + "img/bc_logo.258c08a3.png";